import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=6556ed9a&scoped=true"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"
import style0 from "./paging.vue?vue&type=style&index=0&id=6556ed9a&prod&lang=scss&scoped=true"
import style1 from "./paging.vue?vue&type=style&index=1&id=6556ed9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556ed9a",
  null
  
)

export default component.exports